import React from 'react';
import {Route, Routes} from "react-router-dom";
import TimeKeepingRouter from "./timekeeping/Router";
import Error404 from "../../common/error/Error404";
const HRMRouter = props => {
    return (
        <Routes path={"/"}>
            <Route path="timekeeping/*" element={<TimeKeepingRouter/>}/>
            <Route path="*" element={<Error404/>}/>
        </Routes>
    );
};

HRMRouter.propTypes = {};

export default HRMRouter;